<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">Inicio</h4>
    <div class="row">
      <div class="col-lg-12">
     <div class="row">
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-primary border-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase mb-0 text-white">NO PRESENTO</h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{datos_total.total}}</span>
                  <div class="progress progress-xs mt-3 mb-0">
                    <div class="progress-bar bg-success" style="width: 100%;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-info border-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase mb-0 text-white">EN COLA</h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{datos_total.en_sala}}</span>
                  <div class="progress progress-xs mt-3 mb-0">
                    <div class="progress-bar bg-success" style="width: 100%;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-faded-danger border-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase mb-0 text-white">EN SERVICIO</h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{datos_total.en_modulo}}</span>
                  <div class="progress progress-xs mt-3 mb-0">
                    <div class="progress-bar bg-success" style="width: 100%;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card bg-gradient-warning border-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h5 class="card-title text-uppercase mb-0 text-white">ATENDIDOS</h5>
                  <span class="h2 font-weight-bold mb-0 text-white">{{datos_total.finalizado}}</span>
                  <div class="progress progress-xs mt-3 mb-0">
                    <div class="progress-bar bg-success" style="width: 100%;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">Datos de Turnos</h6>
                </div>
              </div>
           
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import setTooltip from "@/assets/js/tooltip.js";
import axios from "axios";
export default {
  name: "dashboard-default",
  data() {
    return {
      datos_total:"",
    };
  },
  components: {
  },
   created: function () {
    this.getdatosturnostotal();
  },
   mounted() {
    setTooltip(this.$store.state.bootstrap);
  },
  methods:{
    getdatosturnostotal() {
      axios.get("ver_conteo_total")
      .then((response) => {
          this.datos_total = response.data[0];
       }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
  }
};
</script>
